import '@/lib/zod-config';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from '@/app/providers';
import { createAppRouter } from '@/app/routes';
import { installAndroidBackButton } from '@/lib/android-back';
import { createQueryClient } from '@/lib/api/query-client';
import { createAuthClient } from '@/lib/auth/session';
import '@/styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root não encontrado em index.html.');

const queryClient = createQueryClient();
const router = createAppRouter();
const authClient = createAuthClient();
// Android: o botão "voltar" do aparelho fecha o que está aberto, volta a tela ou sai do app (T-231).
void installAndroidBackButton(router);

createRoot(root).render(
  <StrictMode>
    <AppProviders queryClient={queryClient} authClient={authClient}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
